import React from "react";
import NewsletterSignupForm, {
  NEWSLETTER_NAME,
} from "../Forms/NewsletterSignupForm";
import Toast from "../Toast";

const NewsletterSubscriber = ({ headerHTML, contentHTML, successText }) => {
  return (
    <div className="newsletter-subscriber container grid-container">
      <div className="grid-col-12 grid-col-lg-7 text-center text-lg-left">
        <h2 dangerouslySetInnerHTML={{ __html: headerHTML }} />
        <div
          className="mt-3 mb-4"
          dangerouslySetInnerHTML={{ __html: contentHTML }}
        />
        <NewsletterSignupForm
          newsletterName={NEWSLETTER_NAME.ZIPWORLD}
          toastId="zipworld-newsletter"
        />
      </div>

      <Toast
        containerId="zipworld-newsletter"
        toastStatus="success"
        header="Thank you!"
        description={successText}
      />

      <Toast
        containerId="zipworld-newsletter"
        toastStatus="error"
        header="Something went wrong"
        description="Please try again later."
      />
    </div>
  );
};

export default NewsletterSubscriber;
